import { render, staticRenderFns } from "./UpsertArea.vue?vue&type=template&id=e93f52ee&scoped=true"
import script from "./UpsertArea.vue?vue&type=script&lang=ts"
export * from "./UpsertArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93f52ee",
  null
  
)

export default component.exports